import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThemeProvider from "./components/theme/ThemeProvider";
import Navbar from "./components/layout/Navbar";
import Hero from "./components/layout/Hero";
import Menu from "./components/menu/Menu";
import LunchMenu from "./components/menu/LunchMenu";
import BookingSection from "./components/booking/BookingSection";
import Footer from "./components/layout/Footer";
import React from "react";
import RestaurantMap from "./components/map/RestaurantMap";
import WhatsAppButton from "./components/contact/WhatsAppButton";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import OpeningHoursBar from "./components/layout/BookingBanner";
// import BookingErrorBanner from "./components/layout/BookingErrorBanner";

export default function App() {
  // Use a more reliable way to detect environment
  // Check for development environment
  const isDevEnvironment = () => {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1';
  };
  
  return (
    <Router>
      <ThemeProvider>
        <Routes>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route
            path="/"
            element={
              <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
                {/* Display environment-specific banners based on hostname */}
                {isDevEnvironment() && (
                  <div className="bg-yellow-100 text-yellow-800 text-center text-sm py-1">
                    Development Environment
                  </div>
                )}
                {/* <BookingErrorBanner /> */}
                <OpeningHoursBar />
                <Navbar />
                <Hero />
                <LunchMenu />
                <Menu />
                <BookingSection />
                <RestaurantMap />
                <Footer />
                <WhatsAppButton />
              </div>
            }
          />
        </Routes>
      </ThemeProvider>
    </Router>
  );
}
